module["exports"] = [
  "S.A.",
  "LTDA",
  "e Associados",
  "Comércio"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/company/suffix.js
// module id = 1599
// module chunks = 0